<template>
    <div>
        <b-navbar class="px-0" v-if="searchable || $slots.menu || $slots.nav_menu || exportXLSX" style="margin-inline: -15px;">
            <b-col>
                <b-form-input v-if="searchable" v-model="filter" v-on:input="search" placeholder="Поиск"/>
            </b-col>
            <b-col v-if="$slots.menu || $slots.nav_menu || exportXLSX" cols="6">

                <slot name="menu"/>
                
                <b-nav class="d-flex justify-content-end" pills>
                    <slot name="nav_menu"/>
                    <b-button variant="outline-primary" v-if="exportXLSX && !$root.readonly" title="Экспорт таблицы" v-on:click="export_to_XLSX()" v-b-tooltip:fullscreen.hover.bottomright><base-icon name="download" /></b-button>
                    <slot name="nav_menu_end"/>
                </b-nav>

            </b-col>
        </b-navbar>
        <b-table ref="table" :items="trees" :fields="fields" class="hierarchy-table m-0" sticky-header :thead-class="isChild ? 'd-none' : ''">
            <template #cell(expand_sections)="row">
                <b-button v-if="row.item.children.length" class="filter-button" variant="light" @click="row.toggleDetails">
                    <base-icon :name="row.detailsShowing ? 'double_arraow_top' : 'double_arraow_bottom'"/>
				</b-button>
            </template>

            <template #head()="data"><span v-html="data.label" /></template>
    
            <template #row-details="row">
				<div> <!-- class="pl-4" -->
                    <hierarchy_table class="child" v-if="row.item.children.length" :data="row.item.children" :fields_raw="fields_raw" isChild />
                </div>
            </template>
        </b-table>
    </div>
</template>

<script>
import XLSX from "xlsx"
export default
{
    name : "hierarchy_table",
    props :
	{
		fields_raw : { type : Array, default : () => [] },
		data : Array,
        isChild : { type : Boolean, default : false },
        searchable : { type : Boolean, default : false },
        exportXLSX : { type : Boolean, default : false },
        min_width : { type : String, default : null },
        XLSX_name : { type : String, default : "Экспорт" }
	},
	data()
	{
		return {
			filter : null,
            trees : [],
		}
	},
    mounted()
    {
        if (this.min_width !== null)
        {
            this.$refs.table.$el.children[0].style = `min-width: ${this.min_width}`
        }
    },
    computed :
    {
        fields()
        {
			
			if (this.trees.find(e => e.children.length > 0) || this.isChild)
            {
                var fields = Object.assign([], this.fields_raw)
    
                fields.unshift({ key : "expand_sections", label : "", thStyle : "width: 46px;padding: 0", tdClass : ['expand'], })
    
                return fields
            }
            else
            {
                return this.fields_raw
            }
        },
    },
    watch :
    {
        data :
        {
            immediate : true,

            handler(data) {
                this.trees = data
                this.filter = null
            }
        }
    },
    methods :
    {
        search(value)
		{
            if (value)
            {
                const exp = new RegExp(value, "i")
                var new_tree = JSON.parse(JSON.stringify(this.data))
    
                var process =
                    tree =>
                    {
                        tree.forEach(
                            elem => 
                            {
                                elem.children = process(elem.children)
                                elem._showDetails = true
                            })
                        
                        return tree.filter(
                            elem => 
                            {
                                var visible = null
                                
                                for (const field of this.fields_raw)
                                {
                                    const tree_value = elem[field.key]
                                    if (typeof tree_value == "string")
                                        visible = ( tree_value.match(exp) ) != null
                                    else if (typeof tree_value == "number")
                                        visible = ( tree_value.toString().match(exp) ) != null
                                    
                                    if (visible) break
                                }
                                return visible || elem.children.length != 0
                            })
                    }
                
                this.trees = process(new_tree)
            }
            else
            {
                this.trees = this.data
            }
		},
        export_to_XLSX()
        {
            const header_keys = this.fields_raw.map(elem => elem.key)
            const header_labels = this.fields_raw.map(elem => elem.label)

            var rows = []

            var process =
                tree =>
                {
                    tree.forEach(elem => {
                        const { children, ...rest } = elem

                        const row = {}
                        header_keys.forEach(key => row[key] = rest[key])

                        rows.push(row)
                        process(children)
                    })
                }
            process(this.trees)

            
            const worksheet = XLSX.utils.json_to_sheet(rows, { header : header_keys })
            XLSX.utils.sheet_add_aoa(worksheet, [header_labels], { origin: "A1" })

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
            XLSX.writeFile(workbook, `${this.XLSX_name}.xlsx`, { compression: true })
        },
    }
}
</script>

<style>

.hierarchy-table tbody tr > .expand
{
    padding : 0 !important;
    width: 51px;
}

.hierarchy-table .b-table-details > td
{
	padding: 0 !important;
}

.hierarchy-table .child > div > table
{
    border-right: none !important;    
    border-top: none !important;
    border-bottom: none !important;
    border-radius: 0;

    border-left: none !important;
}
</style>
